export const Numerique = "Numerique";
export const Infolettre = "Infolettre";
export const EcranMagasin = "Aff-Numerique";
export const Blogue = "Blogue";
export const VideoWall = "VideoWall";
export const VendeurSilencieux = "Vend-Silencieux";
export const Radio = "Radio";
export const TV = "Tv";
export const Journal = "Journal";
export const SiteWeb = "SiteWeb";
export const Circulaire = "Circulaire";
export const AbriAutobus = "Abribus";
export const AffichageExterieur = "Aff-Exterieur";